import React, { useMemo } from 'react';
import { ROUTE } from 'constant';
import { actions } from 'redux/local';
import { useSelector } from 'react-redux';
import EventStream from 'eventing-bus/lib/event_stream';
import Shared from 'screens/shared';
import UUIDGrapher from './UUIDGrapher';
import GraphController from './GraphController';

const eventBus = new EventStream();
export const MonitoringServerGraphs = ({ match }) => {
  const { serverId } = match.params;
  const { timeRangeSettings: controllerState = {} } = useSelector((e) => e);
  const Grapher = useMemo(() => UUIDGrapher(serverId, eventBus), [serverId]);

  const onChange = (model) => {
    actions.common.quickUpdate({ timeRangeSettings: { ...controllerState, ...model } });
  };

  const handleRefresh = () => {
    eventBus.publish('refresh');
  };

  return (
    <Shared.widgets.Page className="screen-monitoring" isStrap={false} route={ROUTE.DASHBOARD.MONITORING_SERVER}>
      <GraphController onChange={onChange} model={controllerState} onRefresh={handleRefresh} />
      <Grapher fetchParams={controllerState} refreshInterval={controllerState.refreshInterval} />
    </Shared.widgets.Page>
  );
};
